import { useState } from "react";

import { QuantitySelector } from "common/components/subscriptions";
import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "common/components/ui/Dialog";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useLicenseMutations from "common/datahooks/useLicenseMutations";
import usePromotions from "common/datahooks/usePromotions";
import useLicensedAccounts from "common/hooks/useLicensedAccounts";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import LicenseAccounts from "./LicenseAccounts";

export default function ManageAgencySeats() {
  const isDesktop = useTwBreakpoint("lg");
  const {
    agencyPlan: { unassigned_license_count },
  } = usePromotions();
  const { id: workspaceId, lifetime_license_count } =
    useSelectedWorkspaceContext();
  const { setLifetimeLicenseCount, isSettingLifetimeLicenseCount } =
    useLicenseMutations();
  const { agencyLicensedAccounts } = useLicensedAccounts(workspaceId);

  const [seatCount, setSeatCount] = useState(lifetime_license_count);

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button size={isDesktop ? "sm" : "md"} className="ml-auto">
          Manage workspace seats
        </Button>
      </DialogTrigger>
      <DialogContent className="md:w-[448px]">
        <DialogTitle className="mb-10">Manage workspace seats</DialogTitle>
        <QuantitySelector
          quantity={seatCount}
          setQuantity={setSeatCount}
          minValue={0}
          maxValue={unassigned_license_count}
        />
        <div className="flex gap-x-2 mt-4 mb-10">
          <div className="flex flex-col p-3 border flex-1 gap-y-1 rounded-2xl border-black-200">
            <span className="text-black-500">Used</span>
            <div className="flex items-center gap-x-2.5">
              <span className="text-2xl-bold">
                {agencyLicensedAccounts.length}
              </span>
              <LicenseAccounts accounts={agencyLicensedAccounts} />
            </div>
          </div>
          <div className="flex flex-col p-3 border flex-1 gap-y-1 rounded-2xl border-black-200">
            <span className="text-black-500">Available in pool</span>
            <span className="text-2xl-bold text-purple-400">
              {unassigned_license_count}
            </span>
          </div>
        </div>
        <Button
          className="ml-auto"
          isLoading={isSettingLifetimeLicenseCount}
          onClick={() => {
            setLifetimeLicenseCount({ count: seatCount, accountsToCancel: [] });
          }}
        >
          Update seats
        </Button>
      </DialogContent>
    </Dialog>
  );
}
